import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { collections } from '../../mocks/collections';

export default function Collections() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  const handleCollectionClick = (collectionName: string) => {
    navigate('/contact', { state: { collection: collectionName } });
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden pt-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/15"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/3fde0ee968761271b8203315aa033d1f.jpg')`,
            objectPosition: 'center'
          }}
        ></div>
        
        <div className={`relative z-10 text-center px-6 max-w-4xl transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-5xl md:text-7xl font-light mb-6 text-[#4A4A4A] tracking-wide" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Our Collections
          </h2>
          <p className="text-lg md:text-xl font-light text-[#6B6B6B] max-w-2xl mx-auto leading-relaxed">
            Timeless pieces crafted with intention and care
          </p>
        </div>
      </section>

      {/* Collections Grid */}
      <section className="py-32 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {collections.map((collection, index) => (
              <div 
                key={collection.id}
                className="group cursor-pointer"
                onClick={() => handleCollectionClick(collection.name)}
                style={{
                  animation: `fadeInUp 0.8s ease-out ${index * 0.15}s both`
                }}
              >
                <div className="relative overflow-hidden mb-6 aspect-[4/5] rounded-3xl">
                  <img 
                    src={collection.image}
                    alt={collection.name}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <h4 className="text-xl font-light text-[#4A4A4A] mb-2 transition-colors duration-300 group-hover:text-[#C9A961]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  {collection.name}
                </h4>
                <p className="text-sm font-light text-[#8B8B8B] leading-relaxed mb-4">{collection.description}</p>
                <p className="text-sm font-light text-[#C9A961]">Click to inquire</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm font-light text-[#C9A961] tracking-widest mb-6">CRAFTSMANSHIP</p>
          <h3 className="text-4xl md:text-5xl font-light mb-8 text-[#4A4A4A] leading-relaxed" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Every Detail Matters
          </h3>
          <p className="text-lg font-light text-[#6B6B6B] leading-loose mb-6">
            Each piece in our collection undergoes dozens of meticulous processes, using premium materials and completed by experienced craftsmen.
          </p>
          <p className="text-lg font-light text-[#6B6B6B] leading-loose">
            We don't chase extravagance, but focus only on designs that can accompany you for a lifetime.
          </p>
        </div>
      </section>

      <Footer />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500&display=swap');
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
